export const ERROR = 'containers/App/ERROR';
export const LOADED = 'containers/App/LOADED';
